function Component({ step = 1 }) {
  function renderColor(param) {
    switch (param) {
      case "active":
        return "w-6 h-6 rounded-full bg-primary-500 flex justify-center items-center mr-2"
      case "inactive":
        return "w-6 h-6 rounded-full border-dark flex justify-center items-center border text-dark-300 mr-2"
      case "textactive":
        return "text-base mb-2 mr-2 text-dark-100"
      case "textinactive":
        return "text-base mb-2 mr-2 text-dark-300"
      default:
        return ""
    }
  }
  return (
    <div>
      <div className="flex item-center justify-center">
        <div className="flex">
          <div className={step === 1 ? renderColor("active") : renderColor("inactive")}>1</div>{" "}
          <div className={step === 1 ? renderColor("textactive") : renderColor("textinactive")}>Chọn gói cước</div>
          <div className="flex justify-center mx-4 mt-3">
            <div style={{ borderTop: "solid 1px rgb(55 65 81)", opacity: "0.8", width: "40px" }}></div>
          </div>
        </div>
        <div className="flex">
          <div className={step === 2 ? renderColor("active") : renderColor("inactive")}>2</div>{" "}
          <div className={step === 2 ? renderColor("textactive") : renderColor("textinactive")}>
            Chọn thời hạn và phương thức thanh toán
          </div>
          <div className="flex justify-center mx-4 mt-3">
            <div style={{ borderTop: "solid 1px rgb(55 65 81)", opacity: "0.8", width: "40px" }}></div>
          </div>
        </div>
        <div className="flex">
          <div className={step === 3 ? renderColor("active") : renderColor("inactive")}>3</div>{" "}
          <div className={step === 3 ? renderColor("textactive") : renderColor("textinactive")}>Thanh toán</div>
        </div>
      </div>
      {step === 1 && (
        <div className="text-dark-300 mt-2">
          Vui lòng chọn mua một trong những gói sau để trải nghiệm những nội dung đặc sắc trên ứng dụng ON Plus
        </div>
      )}
    </div>
  )
}
export default Component
